import { compose } from "recompose";
import { connect } from "react-redux";
import { getPresence, getStatus } from "src/duck/selectors";
import { withMessenger } from "src/modules/messenger/Provider";
import { withFrame } from "src/components/Frame/Context";
import { withApp } from "src/components/App/Context";
import { getDevicesToNotify } from "src/modules/scheduler/duck/selectors";
import { hasPremium } from "src/modules/auth/duck/selectors";
import {
  getDefaultAvatarId,
  getAvatars
} from "src/modules/avatar/duck/selectors";
import { setDefaultAvatar } from "src/modules/avatar/duck/actions";
import synchronizeAvatars from "src/modules/avatar/duck/epics/synchronizeAvatars";
import { getMotionSensitivity } from "src/modules/baby-station/duck/selectors";
import { getPairedDevices } from "src/modules/device/duck/selectors/index";
import { getCommands } from "src/modules/command/duck/selectors";

import * as selectors from "../duck/selectors";
import * as actions from "../duck/actions";
import BabyStation from "./BabyStation";
import withRouter from "src/routing/withRouter";

function mapStateToProps(state) {
  return {
    appStatus: getStatus(state),
    devicesToNotify: getDevicesToNotify(state),
    presence: getPresence(state),
    micSensitivity: selectors.getMicSensitivity(state),
    micSensitivityCorrection: selectors.getMicSensitivityCorrection(state),
    motionSensitivity: getMotionSensitivity(state),
    pairedDevices: getPairedDevices(state),
    commands: getCommands(state),
    hasPremium: hasPremium(state),
    defaultAvatarId: getDefaultAvatarId(state),
    avatars: getAvatars(state)
  };
}

const enhance = compose(
  withApp,
  withFrame,
  withRouter,
  withMessenger,
  connect(mapStateToProps, {
    synchronizeAvatars,
    setDefaultAvatar,
    setMicSensitivity: actions.setMicSensitivity
  })
);

export default enhance(BabyStation);
